import type { Fact, FactState } from './fact'

export enum IngestionTaskStep {
  Extract = 'EXTRACT',
  Verify = 'VERIFY',
  QA = 'QA',
  Remediation = 'REMEDIATION',
}

export enum IngestionTaskState {
  Blocked = 'BLOCKED',
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE',
  CannotProgress = 'CANNOT_PROGRESS',
}

export type IngestionBatch = {
  id: string
  theme: string
  phase: number
  step: IngestionTaskStep
  totalTasks: number
  completedTasks: number
  outstandingTasks: number
  state: IngestionTaskState
  totalTimeSpent: string
  expectedTimeRemaining: string
  priority: number
}

export type IngestionBatchWithTasks = IngestionBatch & {
  tasks: IngestionTask[]
}

export type IngestionTask = {
  id: number
  taskId: number
  entityId: number
  entityName?: string
  priority: number
  theme: string
  phase: number
  state: IngestionTaskState
  step: IngestionTaskStep
  years: number[]
  userId?: string
  username?: string
  totalTimeSpent?: string
  batchId: IngestionBatch['id']
  type: 'UPDATE' | 'NEW_ENTITY' | 'BACKFILL'
}

export type IngestionTaskFact = Omit<Fact, 'status'> & {
  entityIndustry: string
  metricName: string
  entityName: string
  state: FactState
}
